import { Component } from '@angular/core';
import { Globals } from '../../../../../globals';
import { NavController } from 'ionic-angular';
import { CartasMenusListPage } from '../../../../cartas-menus/cartas-menus-list/cartas-menus-list';
import moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { CartaMenuServices } from '../../../../cartas-menus/services';

@Component({
    selector: 'page-home-cartas-menus',
    templateUrl: 'home-cartas-menus.html'
})


export class HomeCartasMenusPage {
    total_views = 0;
    total_shares = 0;
    total_actives = 0;
    get_analytics = false;

    constructor(public globals: Globals,
        public navCtrl: NavController,
        public http: HttpClient,
        private cartaMenuServices: CartaMenuServices) {
    }

    ngOnInit() {
        if (this.globals.restaurant.plg_cartamenu_finisher == true || this.globals.restaurant.plg_cartamenu_finisher == undefined) {
            this.getAnalytics();
            this.getCartasMenusActiveSahre();
        }
    }

    goToCartaMenu() {
        this.globals.side_menu_active = 'carta';
        this.navCtrl.setRoot(CartasMenusListPage);
        this.globals.side_menu_active_analytics = false;
        this.globals.open_side_menu = false;
    }

    async getAnalytics() {
        const params = new HttpParams()
            .set('rest_uid', this.globals.restaurant_uid)
            .set('first_date', moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .set('last_date', moment().format('YYYY-MM-DD HH:mm:ss'));

        this.http.post(this.globals.analytics_path + 'analytics/total_views_share_general', params, {})
            .subscribe(async response => {
                this.total_views = response['total_views'];
                this.total_shares = response['total_share'];
                this.get_analytics = true;
            });
    }

    async getCartasMenusActiveSahre() {
        var total = 0;
        await this.cartaMenuServices.firestore.collection('menus')
            .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
            .where('digital_app', '==', true)
            .get()
            .then((snapshot) => {
                snapshot.forEach((doc) => {
                    total++;
                });
            })
            .catch((err) => {
            });
        //
        await this.cartaMenuServices.firestore.collection('cartas')
            .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
            .where('digital_app', '==', true)
            .get()
            .then((snapshot) => {
                snapshot.forEach((doc) => {
                    total++;
                });
            })
            .catch((err) => {
            });
        //
        this.get_analytics = true;
        this.total_actives = total;
    }

    openLanding() {
        if (this.globals.so_mobile) {
            window.location.assign('https://ads.mycheftool.com/carta-y-menu-digital');
        } else {
            window.open('https://ads.mycheftool.com/carta-y-menu-digital', '_blank');
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-cards/home-cartas-menus/home-cartas-menus.ts